import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginDto } from '@base/models/login.dto';
import { UserApiService } from '@base/services/user-api.service';
import { ClientDto } from '@client/shared/models/client/client.dto';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ClientApiService extends UserApiService {
  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/client`;
  }

  protected get authEndpoint() {
    return `${environment.basePathAuthentication}`;
  }

  getProfile(): Observable<ClientDto> {
    return this.#http.get<ClientDto>(`${this.endpoint}/profile`);
  }

  override submitLogin(email: string, password: string): Observable<LoginDto> {
    return this.#http.post<LoginDto>(`${this.authEndpoint}/login`, {
      email: email,
      password: password
    });
  }

  override requestPasswordReset(email: string): Observable<any> {
    return this.#http.post(`${this.authEndpoint}/password/request-reset-client`, { email: email });
  }

  override resetPassword(token: string, password: string): Observable<LoginDto> {
    return this.#http.post<LoginDto>(`${this.authEndpoint}/password/reset-client`, { token: token, newPassword: password });
  }
}
